__turbopack_context__.v({
  "input": "multi-select-module__b4eGzW__input",
});
